import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BrowserModule} from '@angular/platform-browser';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {DragulaModule} from 'ng2-dragula';
import {NgSelectModule} from '@ng-select/ng-select';

import {PageItemComponent} from '@components/sidebar/page-item/page-item.component';
import {FavoritesComponent} from '@components/sidebar/favorites/favorites.component';
import {FavoriteItemComponent} from '@components/sidebar/favorites/favorite-item/favorite-item.component';
import {MenuItemComponent} from '@components/sidebar/menu-item/menu-item.component';
import {MenuOverviewComponent} from '@components/sidebar/menu-overview/menu-overview.component';
import {MenuSearchComponent} from '@components/sidebar/menu-search/menu-search.component';
import {
  SearchResultItemComponent
} from '@components/sidebar/menu-search/search-result-item/search-result-item.component';
import {SidebarComponent} from '@components/sidebar/sidebar.component';
import {SearchResultComponent} from '@components/sidebar/menu-search/search-result/search-result.component';
import {EditMenuPageComponent} from '@components/sidebar/modal/edit-menu-page/edit-menu-page.component';

import {SharedModule} from '@shared/shared.module';
import {
  ListMenuItemsComponent
} from '@components/sidebar/modal/edit-menu-page/list-menu-items/list-menu-items.component';
import {NodeDetailComponent} from '@components/sidebar/node-detail/node-detail.component';
import {
  EditPageInlineFormComponent
} from '@components/sidebar/modal/edit-page-inline-form/edit-page-inline-form.component';
import {
  EditNodeInlineFormComponent
} from '@components/sidebar/modal/edit-node-inline-form/edit-node-inline-form.component';
import {
  SecondLevelPageItemComponent
} from '@components/sidebar/second-level-page-item/second-level-page-item.component';
import {LoadingItemsComponent} from '@components/sidebar/loading-items/loading-items.component';


@NgModule({
  declarations: [
    PageItemComponent,
    FavoritesComponent,
    FavoriteItemComponent,
    MenuItemComponent,
    MenuOverviewComponent,
    MenuSearchComponent,
    SearchResultItemComponent,
    SidebarComponent,
    SearchResultComponent,
    EditMenuPageComponent,
    ListMenuItemsComponent,
    NodeDetailComponent,
    EditPageInlineFormComponent,
    EditNodeInlineFormComponent,
    SecondLevelPageItemComponent,
    LoadingItemsComponent
  ],
  exports: [
    PageItemComponent,
    FavoritesComponent,
    MenuItemComponent,
    MenuOverviewComponent,
    MenuSearchComponent,
    SearchResultItemComponent,
    SidebarComponent

  ],
  imports: [
    CommonModule,
    BrowserModule,
    NgbModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    SharedModule,
    DragulaModule.forRoot()
  ]
})
export class SidebarModule {
}
